var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _rect, _rect2, _rect3, _g, _path6, _rect4, _path7, _rect5, _path8, _path9, _rect6, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g2, _ellipse4, _path19, _path20, _path21, _path22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 300,
    viewBox: "0 0 412 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2097_20926)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 277H349C349 277 315.851 243 209.129 243C102.408 243 51 277 51 277Z",
    fill: "#D0DFED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M249.649 265.794C249.649 265.794 234.261 239.445 224.198 226.779C211.495 210.805 196.888 203.21 196.952 192.711C197.012 184.271 207.963 182.851 215.264 188.75C220.059 192.726 224.578 197.025 228.79 201.616C228.79 201.616 224.637 185.216 210.334 169.617C199.759 158.093 202.693 145.066 213.474 141.441C224.256 137.816 230.94 143.618 236.462 155.59C241.499 166.491 241.812 180.47 241.812 180.47C241.812 180.47 247.603 162.745 247.512 151.418C247.393 137.318 240.868 131.151 232.004 116.567C223.458 102.465 237.337 87.741 250.669 90.8016C267.483 94.6628 277.258 97.6588 278.624 85.8547C280.297 71.384 281.61 62.7999 293.207 56.8156C309.434 48.4537 321.662 59.3299 326.939 73.5251C331.241 85.1121 319.974 102.41 319.974 102.41C319.974 102.41 331.665 96.0387 342.078 103.78C353.494 112.306 348.799 127.741 342.463 134.87C336.128 142 316.962 145.914 316.962 145.914C316.962 145.914 331.027 149.892 326.843 161.318C323.162 171.368 311.711 170.283 302.168 167.617C295.074 165.634 279.944 170.165 279.944 170.165C279.944 170.165 300.565 170.207 299.782 183.7C299.099 195.668 286.073 197.556 276.874 199.352C267.674 201.147 260.161 206.659 260.161 206.659C260.161 206.659 273.479 203.133 275.738 213.512C277.996 223.891 269.677 229.611 260.745 232.597C251.813 235.582 249.313 251.328 249.649 265.794Z",
    fill: "#D0DFED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.527 47.969C258.527 47.969 260.727 36.9318 268.715 28.7694C275.442 21.8972 282.759 21.672 283.927 23.828C286.068 27.7831 275.684 35.7849 271.936 38.258C270.395 39.2752 263.318 44.4535 260.112 46.8048C260.207 46.93 260.213 47.1068 260.117 47.2408C259.295 48.3803 258.502 49.5124 257.734 50.6479C261.079 47.6968 266.882 43.0656 272.445 40.9894C280.942 37.818 282.514 40.822 281.521 43.3046C280.527 45.7872 272.126 50.085 265.289 51.6627C262.246 52.3387 259.168 52.8438 256.069 53.1758C254.126 56.2068 252.329 59.3145 250.591 62.6925C253.92 61.0128 263.146 56.9656 271.583 58.8251C282.11 61.145 277.629 67.2675 273.124 67.3622C267.039 67.4911 253.614 64.4061 250.138 63.58C247.894 68.0269 245.733 72.9573 243.461 78.7944C245.726 77.3582 252.485 73.2316 256.571 72.4408C261.537 71.4799 265.393 74.895 264.245 77.81C263.096 80.725 257.142 81.0205 251.71 80.8478C248.37 80.7406 244.575 79.7979 243.214 79.432C240.638 86.1033 237.911 93.952 234.754 103.589C234.381 104.726 234.017 105.902 233.663 107.117C234.554 105.628 238.087 99.975 241.851 97.3545C245.951 94.5002 247.743 96.2606 247.216 98.2483C246.235 101.956 234.889 106.87 233.573 107.429C231.383 115.027 229.605 124.108 228.686 134.6C228.363 138.286 227.902 134.964 227.952 134.52C229.291 122.447 231.309 111.729 234.051 103.361C234.643 101.556 235.219 99.8141 235.782 98.1303C234.78 95.4647 230.772 84.283 231.096 76.6757C231.379 70.0343 232.224 65.6455 235.035 65.1015C237.846 64.5576 239.906 73.9416 239.808 77.7236C239.711 81.4866 237.964 89.9385 236.873 94.8939C241.281 81.9192 244.909 72.577 248.72 64.7754C247.483 63.709 240.38 57.5791 238.173 55.4957C235.751 53.2106 233.381 48.6623 235.337 46.0308C237.293 43.3992 241.479 43.3401 244.986 49.9213C248.001 55.5777 248.728 62.6014 248.873 64.4636C249.049 64.1069 249.224 63.7534 249.401 63.4029C249.336 63.3873 249.303 63.3791 249.303 63.3791C249.303 63.3791 249.356 63.3485 249.457 63.2919C251.261 59.7131 253.12 56.4452 255.133 53.2707C255.052 53.2785 254.971 53.2861 254.889 53.2937C254.889 53.2937 254.957 53.226 255.085 53.1002C254.319 51.8469 249.932 44.6343 248.365 41.2664C246.647 37.5707 245.561 30.7312 248.927 28.8208C252.294 26.9104 253.627 31.1844 255.338 37.3992C256.854 42.9001 255.578 51.1109 255.265 52.9247C255.333 52.8584 255.41 52.7838 255.496 52.7016C256.57 51.0288 257.689 49.3785 258.868 47.7186L258.527 47.969Z",
    fill: "#5CB9CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.187 250.784C160.187 250.784 149.308 236.897 130.902 223.723C108.844 207.965 88.7228 212.727 84.2761 195.109C79.2355 175.142 102.096 169.957 102.096 169.957C102.096 169.957 57.0142 164.061 64.969 137.4C71.1765 116.573 90.5882 126.236 90.5882 126.236C90.5882 126.236 65.5119 90.547 87.1352 82.3986C111.349 73.2569 114.732 112.94 114.732 112.94C114.732 112.94 124.899 90.0949 143.878 102.146C161.554 113.371 141.957 138.434 143.328 142.687C145.461 149.455 150.999 131.007 165.008 140.118C175.683 147.052 169.387 166.186 159.049 189.771C148.788 213.185 155.385 238.426 160.187 250.784Z",
    fill: "#D0DFED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.262 177.64C101.26 177.634 101.258 177.628 101.256 177.622C101.207 173.336 101.081 161.402 101.172 159.013C101.379 153.557 100.829 137.61 95.4691 136.853C92.5468 136.441 87.6471 143.772 89.6521 155.321C91.6281 166.696 98.3197 175.598 100.546 178.306C101.342 180.636 102.167 182.897 103.043 185.127C100.58 182.662 94.3818 176.841 88.7208 174.654C81.4539 171.846 76.3474 170.068 75.8578 174.744C75.3681 179.421 82.8073 183.293 87.6189 184.276C91.7384 185.118 100.914 185.97 103.469 186.197C105.334 190.838 107.436 195.365 109.965 200.113C107.352 198.544 100.639 194.858 93.7068 193.832C84.8259 192.519 81.9548 196.663 83.1565 200.478C84.3582 204.293 90.4578 205.254 94.3836 204.53C97.7665 203.907 107.739 201.609 110.433 200.985C115.528 210.41 122.333 220.778 132.321 234.66C128.315 230.081 120.954 221.868 117.235 218.969C113.61 216.144 103.005 211.39 101.569 214.537C100.134 217.683 103.829 221.678 110.116 226.748C117.442 232.655 131.515 236.84 134.508 237.686C135.729 239.368 136.994 241.1 138.307 242.887C144.641 251.509 153.812 261.106 164.803 271.015C165.207 271.379 168.818 273.303 165.402 270.361C155.654 261.968 147.92 253.753 141.951 246.201C142.534 243.495 145.262 229.993 142.462 226.524C140.89 224.573 137.917 225.058 137.836 231.134C137.77 236.096 140.174 242.608 141.291 245.359C140.505 244.35 139.752 243.353 139.03 242.37C131.744 232.453 125.917 224.224 121.147 216.979C122.321 216.028 126.079 212.881 128.613 209.564C132.583 204.367 136.46 198.321 134.416 195.092C132.373 191.863 126.34 193.177 123.804 198.734C121.645 203.468 120.972 213.586 120.82 216.481C116.579 210.014 113.182 204.329 110.338 198.913C112.987 196.624 126.146 185.125 130.426 178.853C133.485 174.371 130.641 165.563 121.011 174.201C112.842 181.529 110.515 194.494 109.997 198.261C107.822 194.071 105.972 190.031 104.311 185.902C106.287 182.446 108.057 178.872 109.612 175.199C112.855 167.362 114.535 156.031 112.806 153.266C111.077 150.5 107.044 149.873 104.196 160.486C102.051 168.479 102.985 179.224 103.577 184.042C102.769 181.95 102.003 179.826 101.262 177.64Z",
    fill: "#5CB9CA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.6181,
    cy: 32.9954,
    rx: 4.98235,
    ry: 5.06471,
    fill: "#7FBAEA"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.617,
    cy: 41.1911,
    rx: 10.3271,
    ry: 10.4978,
    fill: "#F5AB90"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.7749,
    cy: 58.8712,
    rx: 7.06588,
    ry: 7.18267,
    fill: "#F8E187"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2097_20926)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2097_20926",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 36,
    width: 119,
    height: 247
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 140.147,
    y: 36.5615,
    width: 118.72,
    height: 246.4,
    rx: 13.44,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2097_20926)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 143.704,
    y: 42.7197,
    width: 109.526,
    height: 238.767,
    rx: 6.72,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2097_20926",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 42,
    width: 111,
    height: 240
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 143.704,
    y: 42.7197,
    width: 109.526,
    height: 238.767,
    rx: 6.72,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2097_20926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.524 260.218V286.976H114.367V260.218H284.524Z",
    fill: "#EBEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.524 33.7998V60.5582H114.367V33.7998H284.524Z",
    fill: "#EBEEF9"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.107 36.5615H241.907C251.274 36.5615 258.867 44.1696 258.867 53.5546V265.968C258.867 275.353 251.274 282.962 241.907 282.962H157.107C147.741 282.962 140.147 275.353 140.147 265.968V53.5546C140.147 44.1696 147.741 36.5615 157.107 36.5615ZM157.107 43.7836C151.722 43.7836 147.355 48.1582 147.355 53.5546V265.968C147.355 271.365 151.722 275.739 157.107 275.739H241.907C247.293 275.739 251.659 271.365 251.659 265.968V53.5546C251.659 48.1582 247.293 43.7836 241.907 43.7836H229.894V45.0581C229.894 48.9685 226.73 52.1385 222.827 52.1385H175.481C171.578 52.1385 168.414 48.9685 168.414 45.0581V43.7836H157.107ZM222.827 44.9165C222.749 44.9165 222.686 44.9799 222.686 45.0581V44.9165H222.827Z",
    fill: "#39447A"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 164.787,
    y: 205.121,
    width: 69.44,
    height: 15.68,
    rx: 7.84,
    fill: "#F1C411"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.507 211.281H213.987V214.641H185.507V211.281Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 221.974,
    y: 133.512,
    width: 14.2724,
    height: 14.2953,
    rx: 0.56,
    stroke: "#CCCCE4",
    strokeWidth: 1.68
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225.106 141.22L228.216 143.325L233.528 136.999",
    stroke: "#CCCCE4",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M225.106 172.6L228.216 174.705L233.528 168.379",
    stroke: "#CCCCE4",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 221.974,
    y: 164.892,
    width: 14.2724,
    height: 14.2953,
    rx: 0.56,
    stroke: "#CCCCE4",
    strokeWidth: 1.68
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M161.987 102.641L206.885 102.419",
    stroke: "#CCCCE4",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.085 109.393H206.885",
    stroke: "#CCCCE4",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.085 116.366H206.885",
    stroke: "#CCCCE4",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M162.085 133.799H206.885",
    stroke: "#CCCCE4",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M162.085 140.773H206.885",
    stroke: "#CCCCE4",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M162.085 147.746H206.885",
    stroke: "#CCCCE4",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M162.085 165.179H206.885",
    stroke: "#CCCCE4",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M162.085 172.153H206.885",
    stroke: "#CCCCE4",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M162.085 179.126H206.885",
    stroke: "#CCCCE4",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2097_20926)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.912,
    cy: 106.561,
    rx: 13.9916,
    ry: 13.9992,
    fill: "white"
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 229.031,
    cy: 106.68,
    rx: 8.61023,
    ry: 8.61488,
    fill: "#319787"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M224.726 107.641L227.905 109.791L233.336 103.33",
    stroke: "white",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.122 219.321C290.676 217.893 291.2 216.443 291.707 214.951C291.741 212.098 291.831 203.889 291.769 202.255C291.63 198.552 292.006 187.727 295.643 187.212C297.625 186.931 300.947 191.907 299.585 199.747C298.252 207.407 293.773 213.416 292.226 215.306C291.684 216.893 291.123 218.432 290.527 219.949C292.22 218.256 296.396 214.346 300.212 212.87C305.142 210.962 308.607 209.754 308.938 212.928C309.269 216.102 304.221 218.732 300.957 219.401C298.174 219.971 291.987 220.549 290.226 220.707C288.96 223.853 287.534 226.923 285.818 230.142C287.607 229.069 292.143 226.584 296.825 225.889C302.85 224.995 304.797 227.808 303.981 230.398C303.165 232.987 299.027 233.641 296.364 233.151C294.075 232.73 287.338 231.179 285.491 230.751C282.027 237.153 277.4 244.195 270.606 253.629C273.322 250.523 278.331 244.929 280.859 242.957C283.318 241.039 290.514 237.81 291.487 239.945C292.46 242.08 289.953 244.793 285.686 248.236C280.71 252.251 271.15 255.097 269.132 255.668C268.304 256.807 267.446 257.98 266.557 259.19C262.255 265.04 256.028 271.553 248.565 278.277C248.291 278.525 245.839 279.831 248.159 277.834C254.778 272.138 260.03 266.562 264.084 261.437C263.684 259.575 261.848 250.442 263.744 248.091C264.811 246.767 266.828 247.095 266.881 251.22C266.925 254.571 265.309 258.965 264.546 260.848C265.074 260.17 265.58 259.5 266.066 258.839C271.014 252.11 274.971 246.527 278.211 241.611C277.42 240.971 274.865 238.831 273.142 236.575C270.451 233.049 267.823 228.945 269.209 226.753C270.596 224.561 274.689 225.451 276.407 229.223C277.874 232.442 278.327 239.33 278.428 241.28C281.311 236.889 283.62 233.028 285.553 229.351C283.782 227.82 274.828 219.994 271.92 215.729C269.846 212.688 271.777 206.708 278.308 212.57C283.865 217.558 285.433 226.399 285.777 228.924C287.257 226.077 288.515 223.333 289.645 220.528C288.301 218.176 287.097 215.744 286.04 213.244C283.842 207.925 282.705 200.234 283.878 198.357C285.052 196.479 287.788 196.052 289.718 203.256C291.182 208.723 290.524 216.089 290.122 219.321Z",
    fill: "#5CB9CA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M251.783 280.589C251.783 280.589 251.737 243.316 250.852 230.815C249.898 217.352 246.1 205.163 243.412 197.977C240.387 189.889 236.686 186.965 235.462 187.49C233.395 188.366 239.766 203.718 241.676 208.32C245.552 217.664 247.756 229.959 248.687 238.12C249.693 246.947 251.783 280.589 251.783 280.589Z",
    fill: "#5CB9CA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M249.831 272.062C249.831 272.062 249.189 256.923 243.423 245.571C237.658 234.219 231.275 224.169 224.842 223.119C219.871 222.318 219.04 226.573 221.18 229.558C222.885 231.937 227.512 233.134 225.046 234.23C221.882 235.635 222.381 239.066 224.213 239.934C226.978 241.243 229.884 241.539 229.26 244.522C228.635 247.505 231.348 248.311 234.319 249.852C239.852 252.721 242.045 254.526 244.398 258.265C248.187 264.274 250.267 272.158 249.831 272.062Z",
    fill: "#7ED4E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2097_20926",
    x: 138.147,
    y: 35.5615,
    width: 122.72,
    height: 250.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.882353 0 0 0 0 0.917647 0 0 0 0 0.933333 0 0 0 0.321651 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2097_20926"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2097_20926",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2097_20926",
    x: 207.92,
    y: 89.5615,
    width: 37.9834,
    height: 37.998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223529 0 0 0 0 0.266667 0 0 0 0 0.478431 0 0 0 0.252322 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2097_20926"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2097_20926",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2097_20926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 300,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/sign-in.5083604f.svg";
export { ForwardRef as ReactComponent };